import React, { useState } from "react"

import * as commonApi from "../../../api/commonApi";
import * as util from "../../../util";
import { Common, ERROR, SUCCESS, Url } from "../../../helper"
import { success } from "../../Shared";

import AttachFile from "../../../assets/images/attach_file_add.png"
import DownloadImg from "../../../assets/images/Vector.png"

const ManualImport = ({setIsLoading}) => {
  const [errData, setErrData] = useState();
  const [fileName, setFileName] = useState("");

  const downloadTemplate = () => {

    setIsLoading(true);
    const excelUrl = Url.pupilImportExcel;
    fetch(excelUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "Pupil_import.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch(error => console.error("Error downloading Excel file:", error));
    setIsLoading(false);
  }

  const getUploadUrl = async (event) => {
    setIsLoading(true);
    const selectedFile = event.target.files[0];
    console.log({selectedFile});
    
    if (selectedFile) {
      setFileName(selectedFile.name);
    } else {
      setFileName("");
    }
    const allowedExtensions = /(\.xlsx)$/i; // Regular expression for validating file extensions

    if (!allowedExtensions.exec(selectedFile.name)) {
      setErrData([ERROR.PLEASE_SELECT_FILE_FORMAT]);
      setFileName("");
      return;
    }

    let FileLength = event.target.files.length;
    if (FileLength === 1) {
      const getPupilUrl = await commonApi.uploadURL({ ExcelFile: event.target.value });
      if (!util.isEmptyObject(getPupilUrl)) {
        setIsLoading(true);
        const uploadParams = getPupilUrl.Items.fileUploadUrl;
        const uploadPath = getPupilUrl.Items.filePath[0].excelFilePath;
        if (Array.isArray(uploadParams)) {
          for (let index = 0; index < uploadParams.length; index++) {
            const keyNameArr = Object.keys(uploadParams[index]);
            const keyName = keyNameArr[0];
            // const blobField = document.getElementById(keyName).files[0];
            const blobField = new Blob([selectedFile], { type: selectedFile.type });
            const tempObj = uploadParams[index];
            const result = await fetch(tempObj[keyName], {
              method: "PUT",
              body: blobField
            });
            // setIsLoading(false)
            if (result.status === 200) {
              setIsLoading(true)
              const getPupil = await commonApi.pupilsBulkUpload({ Key: uploadPath });
              setIsLoading(false)
              if (!util.isEmptyArray(getPupil.Items)) {
                setErrData(getPupil.Items)
                setIsLoading(false)
              } else {
                success(SUCCESS.PUPILS_UPLOADED)
                setErrData([])
                setIsLoading(false)
              }
            }
          }
        }
      }
    }
  }

  return (
    <div className="manual-div-main">
      <div><span className="manual-upload-title">{Common.ManualUpload}</span>
        <hr style={{marginTop:"-1px"}}/></div>
      <div className="d-flex justify-content-center align-items-flex-start flex-column" style={{ gap: "30px",marginTop:"-23px" }}>
        <button className="download-template-manual-upload" onClick={() => { downloadTemplate() }}>{Common.DownloadTemplate}<img src={DownloadImg} alt="" style={{width:"18px",height:"18px"}} /></button>
        {/* <button className="upload-pupils-manual-upload">{Common.UploadPupils}<img src={AttachFile} alt="" /></button> */}
        <div className="upload-pupils-manual-upload">
          <input
            type="file"
            onChange={(e) => { getUploadUrl(e) }}
            id="excelFileUploadUrl"
            accept=".xlsx"
            style={{ display: "none" }}
          />
          <label htmlFor="excelFileUploadUrl" style={{ cursor: "pointer" }}>
            {fileName || "Upload Pupils"}
          </label>
          <img src={AttachFile} alt="" />
        </div>
      </div>
      <div><div className="d-flex flex-column align-items-center">
        {
          errData && errData.map((items, i) => <label className="text-danger" key={i}>{items}</label>)
        }
      </div></div>
    </div>
  )
}

export { ManualImport }